import React from 'react';

const Icon = (props) => {
    return <i className={`fa fa-${props.name}`} style={props.style}></i>;
}

export default Icon;


// WEBPACK FOOTER //
// ./src/components/Icon/index.js